import { IconProps } from '@/context/global/types/icon';
import { cn } from '@/context/global/utils/cn';

const IconCorrect = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      className={cn('text-white', className)}
    >
      <g clipPath="url(#clip0_4249_88037)">
        <path
          d="M35.2496 63.3329L18.9171 47.0004L13.3555 52.5229L35.2496 74.417L82.2496 27.417L76.7271 21.8945L35.2496 63.3329Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4249_88037">
          <rect width="94" height="94" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconCorrect;
